module.exports = __webpack_public_path__ + "media/images/caret-d8b73ca20e7e26584a9be2c0461d7c55.svg";